import { createContext, useContext, useState, ReactNode } from 'react';

export enum TagFilterOption {
  All = 'all',
  MyTags = 'myTags',
}

interface TagFilterContextValue {
  filterOption: TagFilterOption;
  setFilterOption: (option: TagFilterOption) => void;
}

const TagFilterContext = createContext<TagFilterContextValue | undefined>(
  undefined,
);

interface TagFilterProviderProps {
  children: ReactNode;
}

export function TagFilterProvider({ children }: TagFilterProviderProps) {
  const [filterOption, setFilterOption] = useState<TagFilterOption>(
    TagFilterOption.All,
  );

  return (
    <TagFilterContext.Provider value={{ filterOption, setFilterOption }}>
      {children}
    </TagFilterContext.Provider>
  );
}

export function useTagFilter() {
  const context = useContext(TagFilterContext);
  if (context === undefined) {
    throw new Error('useTagFilter must be used within a TagFilterProvider');
  }
  return context;
}
